export default "__VITE_ASSET__CcHEIWHM__"